/** Single applicant-level status shared across Online Applications, My Tasks, Office Accounting, and Full Name popup. */
export const studentStatusConst = [
  { id: "status_first", label: "status first" },
  { id: "status_second", label: "status second" },
  { id: "status_third", label: "status third" },
] as const;

export type StudentStatusId = (typeof studentStatusConst)[number]["id"];

export const studentStatusLabels = studentStatusConst.map((item) => item.label);

export const resolveStudentStatusId = (value: string | null | undefined): string => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return "empty";
  const match = studentStatusConst.find(
    (status) => status.id === trimmed || status.label.toLowerCase() === trimmed.toLowerCase(),
  );
  return match?.id ?? "empty";
};

export const resolveStudentStatusLabel = (value: string | null | undefined): string => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return "—";
  const match = studentStatusConst.find(
    (status) => status.id === trimmed || status.label.toLowerCase() === trimmed.toLowerCase(),
  );
  return match?.label ?? trimmed;
};

/** Normalize API / UI value to stable id for PUT /applicants. */
export const formatStudentStatusForApi = (value: string | null | undefined): string => {
  const id = resolveStudentStatusId(value);
  return id === "empty" ? "" : id;
};
